import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ParceiroAuthProvider, useParceiroAuth } from '../../contexts/ParceiroAuthContext';
import ParceiroLayout from '../../components/ParceiroLayout';
import ParceiroLogin from './ParceiroLogin';
import ParceiroDashboard from './ParceiroDashboard';
import ParceiroNovaSolicitacao from './ParceiroNovaSolicitacao';
import ParceiroSolicitacoes from './ParceiroSolicitacoes';
import ParceiroSolicitacaoDetalhe from './ParceiroSolicitacaoDetalhe';
import ParceiroImoveis from './ParceiroImoveis';
import ParceiroFaturas from './ParceiroFaturas';
import ParceiroPerfil from './ParceiroPerfil';

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="spinner" data-testid="loading-spinner" />
  </div>
);

const Protegida = ({ children }) => {
  const { user, loading } = useParceiroAuth();
  const location = useLocation();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/parceiro/login" replace />;
  if (user.senha_temporaria && location.pathname !== '/parceiro/perfil') {
    return <Navigate to="/parceiro/perfil?trocar_senha=1" replace />;
  }
  return <ParceiroLayout>{children}</ParceiroLayout>;
};

const SoDeslogado = ({ children }) => {
  const { user, loading } = useParceiroAuth();
  if (loading) return <Spinner />;
  if (user) return <Navigate to="/parceiro/dashboard" replace />;
  return children;
};

export default function ParceiroApp() {
  return (
    <ParceiroAuthProvider>
      <Routes>
        <Route index element={<Navigate to="/parceiro/dashboard" replace />} />
        <Route path="login" element={<SoDeslogado><ParceiroLogin /></SoDeslogado>} />
        <Route path="dashboard" element={<Protegida><ParceiroDashboard /></Protegida>} />
        <Route path="nova-solicitacao" element={<Protegida><ParceiroNovaSolicitacao /></Protegida>} />
        <Route path="solicitacoes" element={<Protegida><ParceiroSolicitacoes /></Protegida>} />
        <Route path="solicitacoes/:id" element={<Protegida><ParceiroSolicitacaoDetalhe /></Protegida>} />
        <Route path="imoveis" element={<Protegida><ParceiroImoveis /></Protegida>} />
        <Route path="faturas" element={<Protegida><ParceiroFaturas /></Protegida>} />
        <Route path="perfil" element={<Protegida><ParceiroPerfil /></Protegida>} />
        <Route path="*" element={<Navigate to="/parceiro/dashboard" replace />} />
      </Routes>
    </ParceiroAuthProvider>
  );
}
